import { useMemo } from "react";

import { useParams } from "react-router-dom";

import { postTrackingData } from "@/api/endpoints/track";
import useFilterParams from "@/hooks/useFilterParams";
import { ROUTES } from "@/routes_new";
import { EVENT } from "@/tracking_events";
import { stringifyQuery } from "@/utils";
import Button, { ButtonProps } from "@components/Button";

export const Excel = (props: ButtonProps) => {
  const [filters] = useFilterParams();
  const { slug } = useParams<{ slug: string }>();
  const stringifiedFilters = useMemo(
    () => stringifyQuery({ ...filters, tag: slug }),
    [filters, slug]
  );

  return (
    <Button
      variant="secondary"
      href={`${ROUTES.TAG_EXPORT_EXCEL}?${stringifiedFilters}`}
      target="_blank"
      data-testid="excel-export-link"
      onClick={() => postTrackingData(EVENT.SHARE_TAG_CLICKED_EXCEL)}
      {...props}
    >
      {L.MENTIONS_VIEW_TOOLBAR_EXPORT_EXCEL}
    </Button>
  );
};

export const CSV = (props: ButtonProps) => {
  const [filters] = useFilterParams();
  const { slug } = useParams<{ slug: string }>();
  const stringifiedFilters = useMemo(
    () => stringifyQuery({ ...filters, tag: slug }),
    [filters, slug]
  );

  return (
    <Button
      target="_blank"
      data-testid="csv-export-link"
      onClick={() => postTrackingData(EVENT.SHARE_TAG_CLICKED_CSV)}
      href={`${ROUTES.TAG_EXPORT_CSV}?${stringifiedFilters}`}
      {...props}
    >
      {L.MENTIONS_VIEW_TOOLBAR_EXPORT_CSV}
    </Button>
  );
};
